export default "__VITE_ASSET__DJhN3uZA__"